import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserIdleModule } from 'angular-user-idle';

import { AuthFrameComponent } from './auth/auth-frame/auth-frame.component';
import { AuthStorageService } from './storage/auth-storage';
import { EnvironmentService } from './environment/environment.service';
import { LanguageComponent } from './language/language.component';


@NgModule({
  declarations: [
    AuthFrameComponent,
    LanguageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    UserIdleModule.forRoot({idle: 60, timeout: 300, ping: 120})
  ],
  providers: [
    EnvironmentService,
    AuthStorageService,
    LanguageComponent,
    /*{  
      provide: ErrorHandler ,
      useClass: GlobalErrorHandlerService
     }*/
  ],
  exports: [
    LanguageComponent,
    AuthFrameComponent
  ]
})
export class CoreModule { }
